import { Radio } from 'antd';
import styled from 'styled-components';

export const RadioListItem = styled(Radio)`
  width: 100%;
  line-height: 42px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralLighter};

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutralLighter};
  }

  &.ant-radio-wrapper-checked {
    background-color: ${({ theme }) => theme.colors.themeLighter};
  }

  .ant-radio {
    display: none;
  }

  .ant-radio ~ span {
    flex-grow: 1;
    display: inline-flex;
    justify-content: space-between;
  }

  .anticon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  i {
    color: ${({ theme }) => theme.colors.themePrimary};
  }
`;
